import Component from '../Component';
import React from 'react';
import {ToggleButton} from 'reactis-inputs';
import immutable from 'immutable';

export default class GroupsInput extends Component {

	handleChange(l, value) {
		let v = this.props.value;
		if (!v) {
			v = immutable.Map();
		}
		let v2 = v.set(l, value)
		this.props.onChange(v2);
	}

	render() {

		const letters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'w1', 'w2', 'm', 'z']

		let buttons = letters.map((l) => {
			return <ToggleButton title={l.toUpperCase()} className="btntogglemini" onChange={(v) => this.handleChange(l, v)}  value={this.props.value && this.props.value.get(l)} />
		})
		return (
			<div style={this.props.style}>
				{buttons}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Form/GroupsInput.js